import React from 'react';
import { Control, UseFormSetValue, UseFormWatch, FieldErrors } from 'react-hook-form';
import { BankAccountFieldSet } from '@/components/shared';
import { CollaboratorFormData } from '@/features/Collaborators/Edit/Types';
import { CollaboratorFormContext } from "@/features/Collaborators/Edit/Contexts/CollaboratorFormContext";

interface BankingDataTabProps {
    context: CollaboratorFormContext;
    collaboratorId: string;
    control: Control<CollaboratorFormData>;
    setValue: UseFormSetValue<CollaboratorFormData>;
    watch: UseFormWatch<CollaboratorFormData>;
    errors: FieldErrors<CollaboratorFormData>;
    isSubmitting?: boolean;
}

const BankingDataTab: React.FC<BankingDataTabProps> = ({
    context,
    collaboratorId,
    control,
    setValue,
    watch,
    errors,
    isSubmitting = false
}) => {
    return (
        <div className="space-y-6">
            <BankAccountFieldSet
                context={context}
                collaboratorId={collaboratorId}
                control={control}
                setValue={setValue}
                watch={watch}
                errors={errors}
                isSubmitting={isSubmitting}
            />
        </div>
    );
};

export default BankingDataTab;
